import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Савченко Ігор',
  role: 'Голова комісії',
  email: 'education@umcf.org.ua'
}, {
  name: 'Кравченко Наталія',
  role: 'Заступник голови з методичної роботи'
}, {
  name: 'Петренко Дмитро',
  role: 'Відповідальний за безпеку'
}, {
  name: 'Іваненко Олексій',
  role: 'Член комісії'
}];
export function EducationCommission() {
  return <FederationMembersPage title="Комісія з навчання, методичної роботи та безпеки" subtitle="Розробка навчальних програм, методичних рекомендацій та стандартів безпеки" members={members} data-id="element-757" />;
}